import { Link } from 'react-router-dom';

const GUIDES = [
  {
    number: '01',
    title: 'Cabins in Highlands, NC',
    path: '/cabins-in-highlands-nc',
    anchor: 'cabins in Highlands, NC',
    description: (
      <>
        Looking for the perfect place to stay? Our guide to{' '}
        <Link
          to="/cabins-in-highlands-nc"
          className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors font-medium"
        >
          cabins in Highlands, NC
        </Link>
        {' '}covers luxury retreats, pet-friendly rentals, and cozy mountain getaways — all within easy reach of downtown and the area&apos;s iconic waterfalls.
      </>
    ),
    icon: 'ri-home-5-line',
  },
  {
    number: '02',
    title: 'Cabins Near Glen Falls Waterfall',
    path: '/cabins-near-glen-falls-highlands-nc',
    anchor: 'cabins near Glen Falls waterfall',
    description: (
      <>
        Want to stay steps from one of the most beautiful waterfalls in the Blue Ridge Mountains? Our guide to{' '}
        <Link
          to="/cabins-near-glen-falls-highlands-nc"
          className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors font-medium"
        >
          cabins near Glen Falls waterfall
        </Link>
        {' '}highlights the closest and most highly rated options — including Glen Falls Luxury Cabin, the top-rated stay near the falls.
      </>
    ),
    icon: 'ri-water-flash-line',
  },
  {
    number: '03',
    title: 'Things to Do in Highlands, NC',
    path: '/things-to-do',
    anchor: 'things to do in Highlands, NC',
    description: (
      <>
        From spectacular waterfall hikes to acclaimed dining and boutique galleries, there&apos;s no shortage of ways to fill your days. Discover the best{' '}
        <Link
          to="/things-to-do"
          className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#C9A96E] transition-colors font-medium"
        >
          things to do in Highlands, NC
        </Link>
        {' '}— updated seasonally so your itinerary always reflects what&apos;s worth doing right now.
      </>
    ),
    icon: 'ri-compass-3-line',
  },
];

export default function CabinGuidesSection() {
  return (
    <section className="w-full bg-white py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost font-light mb-4">
            / Curated Travel Guides
          </p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-tight">
            Your Guide to the Best Places<br />
            <em className="italic font-light">to Stay in Highlands, NC</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-base leading-relaxed max-w-2xl mx-auto mt-6">
            Handpicked guides covering the best cabins in Highlands, NC — organized by location, style, and what matters most to travelers.
          </p>
          <div className="w-10 h-px bg-[#C9A96E] mx-auto mt-8" />
        </div>

        {/* Guide Blocks */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14">
          {GUIDES.map((guide) => (
            <div key={guide.number} className="flex flex-col">
              {/* Number + Icon */}
              <div className="flex items-center gap-3 mb-5">
                <span className="font-cormorant text-4xl text-[#C9A96E]/40 font-light leading-none">
                  {guide.number}
                </span>
                <div className="w-9 h-9 flex items-center justify-center rounded-full border border-[#2D4A3E]/20">
                  <i className={`${guide.icon} text-[#2D4A3E] text-base`} />
                </div>
              </div>

              {/* Title */}
              <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium leading-snug mb-4">
                {guide.title}
              </h3>

              {/* Divider */}
              <div className="w-8 h-px bg-[#C9A96E]/50 mb-5" />

              {/* Description with inline link */}
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
                {guide.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
